import { Injectable, Logger } from '@nestjs/common';
import { NotificationDataAccessService } from './notification-data-access.service';

@Injectable()
export class NotificationDataAccessWithConsoleService extends NotificationDataAccessService {
  sendMessage(data: {
    toEmailAddress: string | string[];
    subject: string;
    message: string;
    ccEmailAddress?: string | string[];
  }): void {
    Logger.log({ ...data });
  }
}
